import { NavigationResource } from "@control-tower/lib";
import { QuestionEditorResourceConstant, ResourceConstant, PinpointSupportResourceConstant } from "./resource-constant";

// @see {@link https://fontawesome.com/v4/icons/} for icon list
export const LeftMenu: NavigationResource[] = [   
    {
      url: `/dashboard`,
      label: 'Dashboard',
      iconClass: 'home',
      permissionKey: ResourceConstant.viewPermission
      // enable this for your project menu based on the resource defined in membership management
    },
    //{
    //  url: `/FDC/site/builder`,
    //  label: 'Create Form',
    //  iconClass: 'edit',
    //  permissionKey: ResourceConstant.viewPermission
    //},
    //{
    //  url: `/FDC/site/index`,
    //  label: 'Create Question',
    //  iconClass: 'question-circle',
    //  permissionKey: QuestionEditorResourceConstant.viewPermission
    //},   
    // {
    //   url: `/FDC/site/sandbox`,
    //   label: 'Preview',
    //   iconClass: 'binoculars',
    //   permissionKey: ResourceConstant.viewPermission
    // },
    // {
    //   url: `/FDC/page-not-found`,
    //   label: 'Tag Maintenance',
    //   iconClass: 'tags',
    //   permissionKey: ResourceConstant.viewPermission
    // },
    // {
    //   url: `/FDC/delivery-tags`,
    //   label: 'Delivery Conversion',
    //   iconClass: 'random',
    //   permissionKey: ResourceConstant.viewPermission
    //   // Conversion of datapoints to delivery
    // },
    //{
    //  url: `/FDC/question-template`,
    //  label: 'Form Template',
    //  iconClass: 'file-text-o',
    //  // permissionKey: ResourceConstant.viewPermission
    //},    
    {
      url: `/settings`,
      label: 'Settings',
      iconClass: 'cog',
      // permissionKey: ResourceConstant.viewPermission
    },
    {
      url: `/builder/question-editor`,
      label: 'Question Builder',
      iconClass: 'file-text-o',
      permissionKey: QuestionEditorResourceConstant.loadPermission
  },
  {
    url: `/pinpoint-support`,
    label: 'Pinpoint Support',
    iconClass: 'info',
    permissionKey: PinpointSupportResourceConstant.loadPermission
  },
  ];
